import React from 'react';
import { Link } from 'gatsby';

const PaginateLink = ({ tag, url, text, className = "" }) => {
  console.log(url)
  if (!tag) {
    return (
      <span className={className}>
        <Link to={url}>{text}</Link>
      </span>
    );
  } else {
    return <span className={className}>{text}</span>;
  }
};

export default PaginateLink;
